(function () {
  function lfcInitRevealObserver() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = document.querySelectorAll('[data-lfc-reveal]:not([data-lfc-reveal-init])');
    if (!els.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lfc-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) {
      el.dataset.lfcRevealInit = 'true';
      observer.observe(el);
    });
  }
  document.addEventListener('DOMContentLoaded', lfcInitRevealObserver);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', lfcInitRevealObserver);
  }
  window.lfcInitRevealObserver = lfcInitRevealObserver;
})();
